<template>
  <section>
    <h2>Keyboard</h2>
    <dl>
      <dt>ctrl + s</dt>
      <dd>In document detail, save current document.</dd>
      <dt>alt + a</dt>
      <dd>In document detail, append new note.</dd>
      <dt>alt + up</dt>
      <dd>In note text area, focus previous note.</dd>
      <dt>alt + down</dt>
      <dd>In note text area, focus next note.</dd>
      <dt>alt + q</dt>
      <dd>In note text area, toggle quote switch.</dd>
    </dl>
  </section>
</template>

<script>
export default {
  "name": "AboutKeyboard",
};
</script>